import { createContext } from 'react';
export const ThemeContext = createContext(null);
//# sourceMappingURL=themeContext.js.map